// extracted by mini-css-extract-plugin
export var section = "Section-module--section--5iaF4";
export var container = "Section-module--container--EmVN+";
export var content = "Section-module--content--Of+As";